import React from "react";
import Disenoaventuras from "./aventuras/disenoaventuras";
import FooterMenu from './componenteshome/footer';
import MenuEscritorio from './componenteshome/MenuEscritorio';

export default function Aventuras(){
    return <div><Disenoaventuras/><FooterMenu/> <MenuEscritorio/></div>
}